import React from 'react';
import PropTypes from 'prop-types';
import { Tr, Td } from 'react-super-responsive-table';
import DatePicker from '../datepicker/datepicker';
import CurrencyInput from '../currencyinput/static';

// eslint-disable-next-line no-unused-vars
function Payment({ date, amount, remaining, type, value }) {
  const remainingRounded = parseFloat(remaining).toFixed(2);
  return (
    <Tr className={'type-' + type}>
      <Td>
        <DatePicker disabled date={date} labelledBy="payment-date-title" />
      </Td>
      <Td>
        <CurrencyInput value={amount} label="payment-amount-title" />
      </Td>
      <Td>
        <CurrencyInput
          value={remainingRounded}
          label="payment-remaining-title"
        />
      </Td>
    </Tr>
  );
}

Payment.propTypes = {
  date: PropTypes.instanceOf(Date),
  amount: PropTypes.number,
  remaining: PropTypes.number,
  type: PropTypes.string,
  value: PropTypes.number,
};

export default Payment;
